import "../../styles/templates/product.scss";

import '../snippets/product-gallery.js';
import '../components/back-in-stock.js';
import RecipientForm from '../components/recipient-form.js'
import {
  getOmnibusPriceFromAPI,
  renderOmnibusPriceFromAPI,
} from '../vendor/omnibus.js';

$(function () {
  $('.product-template').on('variantChange', function (e) {
    if (e.variant) {
      $('[data-variant-sku]').html(e.variant.sku);
      renderOmnibusPrice(e.variant.id, e.variant.price);
    }
  });

  RecipientForm();

  const initTemplate = () => {
    const variantID =
      document.getElementById('omnibusprice').dataset.omnibus_id;
    const variantPrice =
      document.getElementById('omnibusprice').dataset.variant_price;
    renderOmnibusPrice(variantID, variantPrice);
  };

  const renderOmnibusPrice = async (variantID, variantPrice) => {
    const omnibusContainer = document.getElementById('omnibusprice');
    const brand = document.getElementById('omnibusprice').dataset.omnibus_brand;
    const hasPromo = document.getElementById('omnibusprice').dataset.promo;
    renderOmnibusPriceFromAPI(
      omnibusContainer,
      await getOmnibusPriceFromAPI(brand, variantID),
      variantPrice,
      hasPromo,
    );
  };

  initTemplate();
});
